import { render, staticRenderFns } from "./SymbolGroupTable.vue?vue&type=template&id=5bd426d2&scoped=true&"
import script from "./SymbolGroupTable.vue?vue&type=script&lang=js&"
export * from "./SymbolGroupTable.vue?vue&type=script&lang=js&"
import style0 from "./SymbolGroupTable.vue?vue&type=style&index=0&id=5bd426d2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bd426d2",
  null
  
)

export default component.exports